import type { ProductReviewsQueryVariables, ReviewsQueryVariables } from '#graphql-operations'

export async function reviews(variables: ReviewsQueryVariables) {
  const { data, errors } = await useGraphqlQuery(`reviews`, variables)

  if (errors?.length)
    console.error('GraphQL errors:', errors)

  return data.productReviews
}

export async function productReviews(variables: ProductReviewsQueryVariables) {
  const { data, errors } = await useGraphqlQuery(`productReviews`, variables)

  if (errors?.length)
    console.error('GraphQL errors:', errors)

  return data.product?.reviews
}
